import React from "react";
import { Helmet } from "react-helmet"; // To add meta tags dynamically
import styles from "./AboutMe.module.scss";

export const AboutMe = () => {
	return (
		<>
			<Helmet>
				<title>About Me | Nazim Turdiyev - Software Developer & Educator</title>
				<meta
					name="description"
					content="Hi, I'm Nazim Turdiyev, a software developer and educator passionate about crafting exceptional digital experiences and empowering learners."
				/>
				<meta
					name="keywords"
					content="Nazim Turdiyev, software developer, educator, frontend, backend, React, Node.js, Go, Python, web developer, learning platform"
				/>
				<meta name="author" content="Nazim Turdiyev" />
				<meta
					property="og:title"
					content="About Me | Nazim Turdiyev - Software Developer & Educator"
				/>
				<meta
					property="og:description"
					content="Learn more about Nazim Turdiyev, his work in software development, education, and his platform to empower learners."
				/>
				<meta
					property="og:image"
					content="https://res.cloudinary.com/nzmai/image/upload/c_fill,w_1400,h_2800,g_auto/v1731911110/language-school/images/personal-photo.jpg"
				/>
				<meta property="og:url" content="https://skillerdome.com/about-me" />
				<meta property="og:type" content="website" />
				<meta name="twitter:card" content="summary_large_image" />
				<meta
					name="twitter:title"
					content="About Me | Nazim Turdiyev - Software Developer & Educator"
				/>
				<meta
					name="twitter:description"
					content="Learn more about Nazim Turdiyev, his work in software development, education, and his platform to empower learners."
				/>
				<meta
					name="twitter:image"
					content="https://res.cloudinary.com/nzmai/image/upload/c_fill,w_1400,h_2800,g_auto/v1731911110/language-school/images/personal-photo.jpg"
				/>
			</Helmet>

			{/* Main Content */}
			<div className={styles.container}>
				<div className={styles.header}>
					<h1>About Me</h1>
					<p className={styles.intro}>
						Hi, I&apos;m{" "}
						<span className={styles.highlight}>Nazim Turdiyev</span> 👋
					</p>
					<p className={styles.description}>
						I&apos;m a software developer and educator with a passion for
						crafting exceptional digital experiences. I have created a platform
						for people to learn, play, and grow. With the platform, students
						have an opportunity to take custom lessons on various topics,
						including language learning, STEM subjects, and more.
					</p>
					<div className={styles.personalPhoto}>
						<img
							src="https://res.cloudinary.com/nzmai/image/upload/v1731911110/language-school/images/personal-photo.jpg"
							alt="Nazim Turdiyev's Profile"
						/>
					</div>
				</div>
				<div className={styles.section}>
					<h2>What I Do</h2>
					<ul className={styles.list}>
						<li>
							<strong>Frontend Development:</strong> Building interactive and
							responsive user interfaces with React, modern JavaScript, Python,
							and Go.
						</li>
						<li>
							<strong>Backend Development:</strong> Creating scalable
							server-side solutions with Node.js, Go, and RESTful APIs.
						</li>
						<li>
							<strong>Performance Optimization:</strong> Improving application
							speed and reliability.
						</li>
						<li>
							<strong>Web Security:</strong> Safeguarding applications with
							secure coding practices.
						</li>
						<li>
							<strong>UI/UX Design:</strong> Crafting visually appealing and
							user-friendly interfaces.
						</li>
					</ul>
				</div>
				<div className={styles.section}>
					<h2>My Approach</h2>
					<p>
						I focus on delivering interactive, fun, and engaging learning
						experiences. My goal is to create platforms that empower learners to
						learn, play, and grow.
					</p>
				</div>
				<div className={styles.section}>
					<h2>Let’s Connect</h2>
					<p>
						If you’d like to collaborate or learn more about my work, feel free
						to reach out:
					</p>
					<ul className={styles.contactList}>
						<li>
							Email:{" "}
							<a href="mailto:nazimturdiyev@gmail.com" className={styles.link}>
								nazimturdiyev@gmail.com
							</a>
						</li>
						<li>
							LinkedIn:{" "}
							<a
								href="https://www.linkedin.com/in/nazim-turdiyev-3b1b0718b/"
								className={styles.link}
							>
								linkedin.com/in/nazim-turdiyev
							</a>
						</li>
						<li>
							GitHub:{" "}
							<a href="https://github.com/nazimkazim" className={styles.link}>
								github.com/nazimkazim
							</a>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};
